import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type AppointmentModuleSpecsFragment } from '../../../../api/fragments/AppointmentModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

type AppointmentModuleActionsProps = {
    module: AppointmentModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const AppointmentModuleAction = ({ module, permissions }: AppointmentModuleActionsProps) => {
    const { t } = useTranslation(['appointmentModuleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('appointmentModuleDetails:actions.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown menu={{ items }}>
            <Button type="primary">
                <Space>
                    <span>{t('appointmentModuleDetails:actions.label')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default AppointmentModuleAction;
